<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="10" viewBox="0 0 18 10" fill="currentColor">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M0.270463 0.316063C0.648203 -0.0868571 1.28104 -0.107257 1.68394 0.270463L9 7.12928L16.316 0.270463C16.719 -0.107257 17.3518 -0.0868571 17.7296 0.316063C18.1072 0.718983 18.0868 1.35182 17.684 1.72954L9.68394 9.2296C9.29928 9.5902 8.70072 9.5902 8.31606 9.2296L0.316063 1.72954C-0.0868571 1.35182 -0.107257 0.718983 0.270463 0.316063Z"
     />
  </svg>
</template>
<style scoped>
svg {
  color: #385660;
  transition: all 0.3s ease-in-out;
}
</style>
